import { Api } from '../helpers';

const commentsModel = {
  getCommentsData(params) {
    const queryParams = params;
    const path = 'order/get_comments';
    return Api.get({ path, queryParams });
  },

  addComments(data) {
    const body = data;
    // const queryParams = params;
    const path = 'order/add_comment';
    return Api.post({ path }, { body });
  },
};

export default commentsModel;
